import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-where-to-find-imei-modal',
  imports: [TranslateModule],
  templateUrl: './where-to-find-imei-modal.component.html',
  styleUrl: './where-to-find-imei-modal.component.scss'
})
export class WhereToFindImeiModalComponent {
  private dialog = inject(MatDialogRef<any>);
  public data = inject(MAT_DIALOG_DATA);


  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }
  closeDialog(res?: any): void {
    this.beforeClose();
    this.dialog.close(res);
  }
}